// ═══════════════════════════════════════════════════════════
// PageHeader — EMC page layout pattern
// Breadcrumb · H1 title · Subtitle · Right-side actions
// ═══════════════════════════════════════════════════════════

import { useNavigate } from 'react-router-dom';
import { IconChevronRight } from '@tabler/icons-react';
import { IncidentSelectorPill } from './IncidentSelectorPill';
import './PageHeader.css';

export interface Crumb {
  label: string;
  route?: string;
}

interface PageHeaderProps {
  breadcrumbs?: Crumb[];
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  showIncidentSelector?: boolean;
}

export function PageHeader({ breadcrumbs, title, subtitle, actions, showIncidentSelector }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="page-header">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="page-header-breadcrumb">
          <span
            className="page-header-crumb root"
            onClick={() => navigate('/')}
          >
            EMC
          </span>
          {breadcrumbs.map((crumb, i) => (
            <span key={i} className="page-header-crumb-group">
              <IconChevronRight size={12} className="page-header-crumb-sep" />
              {crumb.route ? (
                <button
                  className="page-header-crumb link"
                  onClick={() => navigate(crumb.route!)}
                >
                  {crumb.label}
                </button>
              ) : (
                <span className="page-header-crumb current">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}

      <div className="page-header-row">
        <div className="page-header-text">
          <h1 className="page-header-title">{title}</h1>
          {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
          {showIncidentSelector && (
            <div style={{ marginTop: 8 }}>
              <IncidentSelectorPill />
            </div>
          )}
        </div>
        {actions && (
          <div className="page-header-actions">{actions}</div>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
